import React from 'react';
import AboutUsImg from '../assets/img/about-us.png';

function About() {
  return (
    <section className="about_area section_gap">
      <div className="container">
        <div className="row justify-content-start align-items-center">
          <div className="col-lg-5">
            <div className="about_img">
              <img className="" src={AboutUsImg} alt="" />
            </div>
          </div>

          <div className="offset-lg-1 col-lg-5">
            <div className="main_title text-left">
              <h2>let me <br/>
                Introduce about <br/>
                myself</h2>
              <p>
                <ul>
                  <li>Over 10 years of experience in software development using Node, PHP, C#, React, Vue, Javascript, Typescript</li>
                  <li>Practical knowledge of object-oriented design, relational databases and client/server technologies</li>
                  <li>Experience with different business solutions, power engineering, web design, artificial intelligence</li>
                  <li>Strong ability to effectively multi-task in a fast-paced environment</li>
                  <li>Motivated towards achieving set goals and deadlines in a timely manner</li>
                  <li>Experienced in customer service and warranty claims</li>
                  <li>Professional and energetic work attitude</li>
                  <li>Hardworking, willing to do various job duties with energy</li>
                  <li>Quality communication skills</li>
                  <li>Committed to providing first-class service to guests</li>
                  <li>Flexible team-player, interpersonal skills, responsible, accurate, punctual</li>
                </ul>
              </p>
              <p>
              Facing various problems and solving them, I could master various technologies as well as different frameworks. So I have confidence to do everything I decide.
              </p>
              <p>
              Now I am working as a full-time freelancer. I enjoy talking to clients and my goal is to make them happy and satisfied.
              </p>
              <p>
              In my free time, I love solving math problems and building a website of my own. I also love playing tennis and badminton.
              </p>
              <p>   
                Anh
              </p>
              <a className="primary_btn" target="_blank" rel="noopener noreferrer" href="/CV-Anh.pdf"><span>Download CV</span></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About;